<div mat-dialog-title style="margin:0px;">{{ PageTitle }}</div>

<mat-dialog-content>
    <!-- Module / Portal List page -->
    <div style="padding: 10px;">
        {{ Message }}

        <div class="flex-content">
            <div style="overflow:auto;flex-grow:1;">
                <!-- Angular Material Comments table definition -->
                <mat-table [dataSource]="dataSource" #table multiTemplateDataRows
                    matSort matSortDisableClear matSortActive="AreaName, SubAreaName" matSortDirection="desc"
                    aria-label="Module / Portal List Table" tabindex="0">

                    <ng-container matColumnDef="AreaName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span translate *ngIf="PageTitle == 'Module / Portal List'">Module</span>
                            <span translate *ngIf="PageTitle == 'Page & Tab / View List'">Page</span>
                            <filter *ngIf="dataSource != null && dataSource != undefined" [data]="dataSource" class="mat-filter" columnName="AreaName" dataType="string"
                                #filter></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let area" id="{{area.Area_ID}}">{{ area.AreaName }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="SubAreaName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span translate *ngIf="PageTitle == 'Module / Portal List'">Portal</span>
                            <span translate *ngIf="PageTitle == 'Page & Tab / View List'">Tab / View</span>
                            <filter *ngIf="dataSource != null && dataSource != undefined" [data]="dataSource" class="mat-filter" columnName="SubAreaName" dataType="string"
                                #filter></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let area">{{ area.SubAreaName }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Action">
                        <mat-header-cell *matHeaderCellDef>
                            <span translate>Action</span>
                            <filter *ngIf="dataSource != null && dataSource != undefined" [data]="dataSource" class="mat-filter"
                                columnName="Action" dataType="boolean" #filter></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let area">
                            <tyl-mat-menu [topMenuItems]="topActionMenuItems"
                                (menuClick)="setAreaId(area.Area_ID); setAreaName(area.AreaName); setSubAreaName(area.SubAreaName); actionMenuClick($event); " [data]="dataSource"
                                image="actions.png" [iconWidth]="30">
                            </tyl-mat-menu>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true">
                    </mat-header-row>
                    <mat-row *matRowDef="let row; columns: columnsToDisplay" tabindex="0"
                        [attr.aria-label]="getAriaRow(row)"
                        [ngStyle]="{'border-bottom-width': '0px'}"
                        style="padding:0px;overflow: hidden;" matRipple
                        (keydown)="rowKeyPress($event, row)">
                    </mat-row>
                </mat-table>

            </div>
            <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
        </div>
        <!-- End Element List -->
    </div>

</mat-dialog-content>

   <!-- Footer -->
   <mat-dialog-actions>
    <div class="flex-footer-left">
        <tyl-button *ngIf= "PageTitle == 'Module / Portal List'" id="btnCreate" image="add.png" label="Add Portal" aria-label="Add Portal Button" (click)="showPortalAddWindow()"></tyl-button>
        <tyl-button *ngIf= "PageTitle != 'Module / Portal List'" id="btnCreate" image="add.png" label="Add Page or Tab / View" aria-label="Add Page or Tab / View Button" (click)="showPageTabAddWindow()"></tyl-button>
    </div>
    <div class="flex-footer-right">
        <tyl-button id="closeButton" image="cancel.png" label="Close" aria-label="Close Button" (click)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>
